import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2ncsmapy03: FaireBrandEntity = {
  token: "b_2ncsmapy03",
  type: "brand",
  name: "Olipop",
  avatarUrl:
    "https://cdn.faire.com/fastly/082099f8e5aa13e825cd01cdb7c977e31c02ee65629ef427bf37186a981e61d1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0c96e2974017367c6ebe5c394a927d62818359a6722c060a0d4ec417fbe64a92.png",
  logoUrl:
    "https://cdn.faire.com/fastly/082099f8e5aa13e825cd01cdb7c977e31c02ee65629ef427bf37186a981e61d1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0c96e2974017367c6ebe5c394a927d62818359a6722c060a0d4ec417fbe64a92.png",
  location: "Oakland, CA, USA",
  minimumOrderDollars: 240,
  rating: 4.4,
  reviewCount: 38,
  isInsider: true,
  description:
    "For over a decade, Ben and David have shared a vision of a healthier, tastier future. Their quest for a product that could undermine the old guard of soda behemoths led them to OLIPOP: a new kind of soda that found its taste in wholesome, hardworking ingredients instead of spoonfuls of sugar.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:05.993Z",
    importedBy: "entity-db-cli",
  },
};
